var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1T(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 766,
    height: 1100,
    viewBox: "0 0 766 1100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_13498)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 766,
    height: 1100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_458_13498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.5051 445H-1708V-1L680.56 -0.5L2364 -1V445H853.83C788.743 445 728.837 364.687 698.841 352.596C668.844 340.505 638.435 343.461 608.29 352.596C581.533 360.703 562.67 369.708 546.693 377.336C528.876 385.843 514.646 392.636 497.059 394.561C428.704 402.044 392.245 373.977 361.74 350.493C351.12 342.317 341.222 334.697 330.951 329.326C287.76 306.741 258.161 298.671 200.635 302.705C140.743 306.907 93.4054 346.084 64.3641 394.561C34.1077 445.066 -23.5051 445 -23.5051 445Z",
    fill: "#C4DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.901 875.447C591.325 903.585 615.701 909.093 623.372 909.093C631.042 909.093 792 909.547 792 909.547L791.882 1514H0V881.845C18.3407 881.845 34.3121 876.657 62.3625 853.042C74.23 842.789 106.479 821.583 155.821 835.537C197.913 847.44 205.363 860.31 230.173 862.844C298.71 869.846 330.048 844.606 359.63 830.169C391.753 814.493 413.767 808.892 456.551 811.692C501.095 814.609 530.589 852.454 557.901 875.447Z",
    fill: "url(#paint0_linear_458_13498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.957 178C623.005 178 611.338 187.734 608.387 200.766C605.942 197.54 602.077 195.449 597.713 195.449C595.081 195.449 592.633 196.217 590.564 197.525C587.656 196.196 584.424 195.449 581.015 195.449C568.345 195.449 558.075 205.697 558.075 218.339C558.075 220.954 544.225 223.466 545.034 225.81H719.872C718.945 224.073 705.217 222.756 703.281 222.219C702.583 215.779 697.119 210.765 690.48 210.765C690.14 210.765 689.806 210.791 689.472 210.818C687.101 202.256 679.247 195.967 669.913 195.967C667.969 195.967 666.089 196.246 664.309 196.757C660.087 185.789 649.437 178 636.957 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.084 235.404C699.118 233.991 697.711 233.101 696.145 233.101C693.229 233.101 690.865 236.189 690.865 240C690.865 236.189 688.501 233.101 685.585 233.101C684.021 233.101 682.616 233.989 681.65 235.399M686.258 217.008C685.292 215.594 683.886 214.706 682.322 214.706C679.406 214.706 677.041 217.794 677.041 221.604C677.041 217.794 674.677 214.706 671.759 214.706C670.197 214.706 668.79 215.594 667.824 217.004",
    stroke: "#0068A9",
    strokeWidth: 1.512,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.621 79.9999C186.307 79.9999 193.571 86.0603 195.408 94.1732C196.93 92.1653 199.336 90.8633 202.053 90.8633C203.692 90.8633 205.216 91.3416 206.505 92.1558C208.315 91.328 210.327 90.8633 212.449 90.8633C220.337 90.8633 226.732 97.2434 226.732 105.114C226.732 106.742 235.354 108.306 234.85 109.765H126C126.577 108.684 135.123 107.864 136.329 107.53C136.764 103.521 140.165 100.399 144.299 100.399C144.51 100.399 144.718 100.415 144.926 100.431C146.402 95.1013 151.292 91.1857 157.103 91.1857C158.313 91.1857 159.484 91.3592 160.592 91.6776C163.221 84.849 169.851 79.9999 177.621 79.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.761 81.8676C191.461 81.8676 187.865 84.9099 186.956 88.9826C186.202 87.9746 185.011 87.321 183.666 87.321C182.854 87.321 182.1 87.5611 181.462 87.9698C180.566 87.5543 179.57 87.321 178.519 87.321C174.614 87.321 171.448 90.5237 171.448 94.4747C171.448 95.2922 175.69 96.0771 175.939 96.8096H213.415C213.415 96.8096 216.8 95.8553 216.203 95.6873C215.988 93.6748 214.304 92.1078 212.258 92.1078C212.153 92.1078 212.05 92.1159 211.947 92.1241C211.217 89.4484 208.796 87.4828 205.919 87.4828C205.32 87.4828 204.74 87.5699 204.192 87.7297C202.89 84.3018 199.608 81.8676 195.761 81.8676Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_13498",
    x1: 907.5,
    y1: 1256.5,
    x2: 338.425,
    y2: 1878.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121921,
    stopColor: "#6ABC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#23A2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998455,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998569,
    stopColor: "#0095D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_13498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 766,
    height: 1100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_458_13498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 1100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1T);
export default __webpack_public_path__ + "static/media/img-1-t.2b5592997df1b4ddd1ff0764adda2e25.svg";
export { ForwardRef as ReactComponent };